import { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import { useToast } from '../../context/ToastContext'
import { Input } from '../../components/forms'
import Button from '../../components/ui/Button'

function SignupForm() {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [loading, setLoading] = useState(false)

  const { signUp, isDemoMode } = useAuth()
  const navigate = useNavigate()
  const toast = useToast()

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!name || !email || !password) {
      toast.error('Please fill in all fields')
      return
    }

    if (password !== confirmPassword) {
      toast.error('Passwords do not match')
      return
    }

    if (password.length < 6) {
      toast.error('Password must be at least 6 characters')
      return
    }

    setLoading(true)

    const { user, error } = await signUp(email, password, name)

    setLoading(false)

    if (error) {
      toast.error(error)
      return
    }

    toast.success('Account created! Please check your email to verify.')
    navigate('/login')
  }

  if (isDemoMode) {
    return (
      <div style={{ textAlign: 'center' }}>
        <p className="text-muted mb-4">
          Sign up is not available in demo mode.
        </p>
        <p className="text-sm text-muted">
          Please configure Supabase to enable account creation.
        </p>
        <Link to="/login" className="btn btn-primary mt-4">
          Back to Login
        </Link>
      </div>
    )
  }

  return (
    <form onSubmit={handleSubmit}>
      <Input
        label="Full Name"
        type="text"
        name="name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        placeholder="John Doe"
        autoComplete="name"
        required
      />

      <Input
        label="Email"
        type="email"
        name="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="you@example.com"
        autoComplete="email"
        required
      />

      <Input
        label="Password"
        type="password"
        name="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        placeholder="••••••••"
        autoComplete="new-password"
        required
      />

      <Input
        label="Confirm Password"
        type="password"
        name="confirmPassword"
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
        placeholder="••••••••"
        autoComplete="new-password"
        required
      />

      <Button
        type="submit"
        variant="primary"
        className="w-full mt-4"
        loading={loading}
      >
        Create Account
      </Button>

      <div className="login-footer">
        <p className="text-sm text-muted">
          Already have an account?{' '}
          <Link to="/login">Sign in</Link>
        </p>
      </div>
    </form>
  )
}

export default SignupForm
